const TreeNode = require('../TreeNode');
const BattleCalc = require('../../BattleCalc');
const Q_which_aoe = require('./Q_which_aoe');
const Q_better_to_melee = require('./Q_better_to_melee');
const AICalc = require('../AICalc');

const DPSRangedDecision = function (actor, battleState) {
  const node = new TreeNode(actor, battleState);

  const arrowShot = BattleCalc.getEquippedAbility(actor, 'arrow_shot');
  const voidSpike = BattleCalc.getEquippedAbility(actor, 'void_spike');
  const infectMind = BattleCalc.getEquippedAbility(actor, 'infect_mind');
  const razorShot = BattleCalc.getEquippedAbility(actor, 'razor_shot');

  node.branches.YES_CLUSTER = new Q_which_aoe(actor, battleState);
  node.branches.NO_CLUSTER = new Q_better_to_melee(actor, battleState);

  node.query = function () {
    const bestTarget = AICalc.getBestMissileTarget(actor, battleState);
    if (!bestTarget) {
      return null;
    }

    // if there is a cluster of enemies, we'll try to use an AoE attack
    const enemyCluster = AICalc.defineEnemyCluster(
      bestTarget,
      battleState.getEnemiesOfUnit(actor)
    );

    if (
      enemyCluster.length > 2 ||
      (!arrowShot && !voidSpike && !infectMind && !razorShot)
    ) {
      return node.branches.YES_CLUSTER.query(bestTarget);
    } else {
      return node.branches.NO_CLUSTER.query(bestTarget);
    }
  };

  return node;
};
module.exports = DPSRangedDecision;
